import { frontendURL } from '../../../../helper/URLHelper';

const ads = accountId => ({
  parentNav: 'ads',           // nests under the "ADS" primary tab
  routes: ['ads_campaigns', 'ads_leads', 'ads_funnel'],          // must exactly match the route's `name`
  menuItems: [
    {
      icon: 'megaphone',                 // pick any Chatwoot icon
      label: 'ADS_CAMPAIGNS',     // Translation key
      key: 'adsCampaigns',           // 🔑 required
      toState: frontendURL(
        `accounts/${accountId}/ads/campaigns`
      ),
      toStateName: 'ads_campaigns',   // again, must match the route's name
    },
    {
      icon: 'people-team',                 // pick any Chatwoot icon
      label: 'ADS_LEADS',     // Translation key
      key: 'adsLeads',           // 🔑 required
      toState: frontendURL(
        `accounts/${accountId}/ads/ads_leads`
      ),
      toStateName: 'ads_leads',   // again, must match the route's name
    },
    {
      icon: 'filter',                 // pick any Chatwoot icon
      label: 'ADS_FUNNEL',     // Translation key
      key: 'adsFunnel',           // 🔑 required
      toState: frontendURL(
        `accounts/${accountId}/ads/funnel`
      ),
      toStateName: 'ads_funnel',   // again, must match the route's name
    },
  ],
});

export default ads;